export const SMALL_WIDTH = '1000px';
export const MEDIUM_WIDTH = '1210px';
export const LARGE_WIDTH = '1400px';
